import { ErrorHandler, Injectable, NgZone } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private _zone: NgZone) {}

  /**
   * Handles global errors in the application.
   *
   * @param {*} error
   * @memberof GlobalErrorHandlerService
   */
  public handleError(error: Error): void {
    this._zone.run(() => {
      // eslint-disable-next-line no-console
      console.error('An unexpected error occurred ***:', error);
    });
  }
}
